import { useStaticQuery, graphql } from "gatsby"

const useCreativesBlogs = () => {
  const query = useStaticQuery(graphql`
    query creativeBlogs {
      posts: allGhostPost(
        filter: {tags: {elemMatch: {slug: {in: ["hash-creativecommunity"]}}}}
        sort: {order: DESC, fields: [published_at]}
        limit: 1000
        skip: 0
      ) {
        edges {
          node {
            id
            title
            slug
            feature_image
            excerpt
            published_at(formatString: "DD MMMM YYYY")
            primary_author {
              name
              slug
              profile_image
            }
            tags {
              name
              slug
            }
          }
        }
        totalCount
      }
    }
  `);

  return query;
}

export default useCreativesBlogs;
